export default "__VITE_ASSET__BExTWft0__"